import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Container, Row, Col } from 'react-bootstrap';
import Admissionleft from './Admissoinleft';
import { Link } from 'react-router-dom';

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission"/>
            <section className="project-detail">
                <Container>
                    <Row>
                        <Col md={4} className='c-left custom-padding-color mb-4'>
                            <Admissionleft activeIndex={3} />
                        </Col>

                        <Col md={8} className='c-right'>
                            <div>
                                <div className="c-heading">
                                    <h3>Master of Science</h3> <br />
                                </div>

                                <div className="border border-dark p-3">

                                      {/* <p className="fw-bold"> <span className="glowing-text">JAM-2025 application portal (JOAPS) is live from 3 September 2024 . The link for the portal is - {" "}
                                <Link to={"https://joaps.iitd.ac.in/"} target="_blank;" className="c-link"> https://joaps.iitd.ac.in/ </Link></span> </p>  */}

                                {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for M.Sc. on July 26, 2024 - {" "}
                                <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_Mtech_Msc_MPP_2024.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p> */}
                                
                                    <p >IIT Tirupati offers M.Sc. degree in Chemistry, Mathematics & Statistics, <b>Mathematics</b> and Physics through Joint Admissions test for Masters (JAM). For more details visit JAM2025 (<Link to="https://jam2025.iitd.ac.in/" target="_blank;" className='c-link'>https://jam2025.iitd.ac.in/</Link>).</p>

                                    <p >The applicable tuition and other fee / deposits for M.Sc. students is available at the following <Link className='c-link' to="/fee-structure">link</Link>.</p>

                                    <p > <b>Please write to <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link>  for any questions or queries regarding admission related matters. </b></p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </section>
        </>
    )
}

export default Main